/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AcceptAgreementRequest,
  DeviceRegistrationRequest,
  DeviceRegistrationResponse,
  NotificationSettingsResponse,
  PendingAgreementsResponse,
  ProblemDetails,
  UpdateExternalUserRequest,
  UpdateNotificationSettingsRequest,
  UpdateUserProfileRequest,
  UserAgreementsResponse,
  UserOrganizations,
  UserProfile,
} from '../missionImpactAuthAPI.schemas';

import { instance } from '../../mutator-auth';
import type { ErrorType } from '../../mutator-auth';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Updates the authenticated user's given name and/or surname in Microsoft Entra External ID.
 * @summary Update profile in External ID
 */
export const updateExternalUserProfile = (
  updateExternalUserRequest: UpdateExternalUserRequest,
  options?: SecondParameter<typeof instance>
) => {
  return instance<void>(
    {
      url: `/v1/me/external-profile`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateExternalUserRequest,
    },
    options
  );
};

export const getUpdateExternalUserProfileMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExternalUserProfile>>,
    TError,
    { data: UpdateExternalUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExternalUserProfile>>,
  TError,
  { data: UpdateExternalUserRequest },
  TContext
> => {
  const mutationKey = ['updateExternalUserProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExternalUserProfile>>,
    { data: UpdateExternalUserRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateExternalUserProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExternalUserProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExternalUserProfile>>
>;
export type UpdateExternalUserProfileMutationBody = UpdateExternalUserRequest;
export type UpdateExternalUserProfileMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update profile in External ID
 */
export const useUpdateExternalUserProfile = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateExternalUserProfile>>,
      TError,
      { data: UpdateExternalUserRequest },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateExternalUserProfile>>,
  TError,
  { data: UpdateExternalUserRequest },
  TContext
> => {
  const mutationOptions = getUpdateExternalUserProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the profile information for the currently authenticated user.
 * @summary Get authenticated user's profile
 */
export const getMe = (options?: SecondParameter<typeof instance>, signal?: AbortSignal) => {
  return instance<UserProfile>({ url: `/v1/me`, method: 'GET', signal }, options);
};

export const getGetMeQueryKey = () => {
  return [`/v1/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>;
  request?: SecondParameter<typeof instance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) =>
    getMe(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ProblemDetails>;

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get authenticated user's profile
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates the profile preferences for the currently authenticated user. Only provided fields are updated. Billing country can only be set once.
 * @summary Update authenticated user's profile
 */
export const updateMe = (
  updateUserProfileRequest: UpdateUserProfileRequest,
  options?: SecondParameter<typeof instance>
) => {
  return instance<void>(
    {
      url: `/v1/me`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserProfileRequest,
    },
    options
  );
};

export const getUpdateMeMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMe>>,
    TError,
    { data: UpdateUserProfileRequest },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  { data: UpdateUserProfileRequest },
  TContext
> => {
  const mutationKey = ['updateMe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMe>>,
    { data: UpdateUserProfileRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateMe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof updateMe>>>;
export type UpdateMeMutationBody = UpdateUserProfileRequest;
export type UpdateMeMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update authenticated user's profile
 */
export const useUpdateMe = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMe>>,
      TError,
      { data: UpdateUserProfileRequest },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  { data: UpdateUserProfileRequest },
  TContext
> => {
  const mutationOptions = getUpdateMeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the acceptance status of all legal documents (Privacy Policy, Terms of Use) for the authenticated user. Shows accepted version, acceptance date, current version, and whether the user is up-to-date for each document type.
 * @summary Get agreement status
 */
export const getMeAgreements = (
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<UserAgreementsResponse>(
    { url: `/v1/me/agreements`, method: 'GET', signal },
    options
  );
};

export const getGetMeAgreementsQueryKey = () => {
  return [`/v1/me/agreements`] as const;
};

export const getGetMeAgreementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeAgreements>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeAgreements>>, TError, TData>>;
  request?: SecondParameter<typeof instance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeAgreementsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeAgreements>>> = ({ signal }) =>
    getMeAgreements(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeAgreements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMeAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getMeAgreements>>>;
export type GetMeAgreementsQueryError = ErrorType<ProblemDetails>;

export function useGetMeAgreements<
  TData = Awaited<ReturnType<typeof getMeAgreements>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeAgreements>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeAgreements>>,
          TError,
          Awaited<ReturnType<typeof getMeAgreements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeAgreements<
  TData = Awaited<ReturnType<typeof getMeAgreements>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeAgreements>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeAgreements>>,
          TError,
          Awaited<ReturnType<typeof getMeAgreements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeAgreements<
  TData = Awaited<ReturnType<typeof getMeAgreements>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeAgreements>>, TError, TData>>;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get agreement status
 */

export function useGetMeAgreements<
  TData = Awaited<ReturnType<typeof getMeAgreements>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeAgreements>>, TError, TData>>;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMeAgreementsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the list of agreements (Privacy Policy, Terms of Use) that require user acceptance.
 * @summary Get pending agreements
 */
export const getMeAgreementsPending = (
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<PendingAgreementsResponse>(
    { url: `/v1/me/agreements/pending`, method: 'GET', signal },
    options
  );
};

export const getGetMeAgreementsPendingQueryKey = () => {
  return [`/v1/me/agreements/pending`] as const;
};

export const getGetMeAgreementsPendingQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeAgreementsPending>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMeAgreementsPending>>, TError, TData>
  >;
  request?: SecondParameter<typeof instance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeAgreementsPendingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeAgreementsPending>>> = ({ signal }) =>
    getMeAgreementsPending(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeAgreementsPending>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMeAgreementsPendingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeAgreementsPending>>
>;
export type GetMeAgreementsPendingQueryError = ErrorType<ProblemDetails>;

export function useGetMeAgreementsPending<
  TData = Awaited<ReturnType<typeof getMeAgreementsPending>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeAgreementsPending>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeAgreementsPending>>,
          TError,
          Awaited<ReturnType<typeof getMeAgreementsPending>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeAgreementsPending<
  TData = Awaited<ReturnType<typeof getMeAgreementsPending>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeAgreementsPending>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeAgreementsPending>>,
          TError,
          Awaited<ReturnType<typeof getMeAgreementsPending>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeAgreementsPending<
  TData = Awaited<ReturnType<typeof getMeAgreementsPending>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeAgreementsPending>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get pending agreements
 */

export function useGetMeAgreementsPending<
  TData = Awaited<ReturnType<typeof getMeAgreementsPending>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeAgreementsPending>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMeAgreementsPendingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Binds a logical device ID to the authenticated user. Rate limited to 5 devices per user.
 * @summary Register device
 */
export const postMeDevicesRegister = (
  deviceRegistrationRequest: DeviceRegistrationRequest,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<DeviceRegistrationResponse>(
    {
      url: `/v1/me/devices:register`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: deviceRegistrationRequest,
      signal,
    },
    options
  );
};

export const getPostMeDevicesRegisterMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMeDevicesRegister>>,
    TError,
    { data: DeviceRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMeDevicesRegister>>,
  TError,
  { data: DeviceRegistrationRequest },
  TContext
> => {
  const mutationKey = ['postMeDevicesRegister'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMeDevicesRegister>>,
    { data: DeviceRegistrationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postMeDevicesRegister(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMeDevicesRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMeDevicesRegister>>
>;
export type PostMeDevicesRegisterMutationBody = DeviceRegistrationRequest;
export type PostMeDevicesRegisterMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Register device
 */
export const usePostMeDevicesRegister = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMeDevicesRegister>>,
      TError,
      { data: DeviceRegistrationRequest },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMeDevicesRegister>>,
  TError,
  { data: DeviceRegistrationRequest },
  TContext
> => {
  const mutationOptions = getPostMeDevicesRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns all organizations where the authenticated user has an active role. Automatically filters out declined invitations, expired invitations (for Invited state), and expired memberships.
 * @summary List user organizations
 */
export const getMeOrganizations = (
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<UserOrganizations>(
    { url: `/v1/me/organizations`, method: 'GET', signal },
    options
  );
};

export const getGetMeOrganizationsQueryKey = () => {
  return [`/v1/me/organizations`] as const;
};

export const getGetMeOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeOrganizations>>, TError, TData>>;
  request?: SecondParameter<typeof instance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeOrganizationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeOrganizations>>> = ({ signal }) =>
    getMeOrganizations(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMeOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeOrganizations>>
>;
export type GetMeOrganizationsQueryError = ErrorType<ProblemDetails>;

export function useGetMeOrganizations<
  TData = Awaited<ReturnType<typeof getMeOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeOrganizations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getMeOrganizations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeOrganizations<
  TData = Awaited<ReturnType<typeof getMeOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeOrganizations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getMeOrganizations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeOrganizations<
  TData = Awaited<ReturnType<typeof getMeOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeOrganizations>>, TError, TData>>;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List user organizations
 */

export function useGetMeOrganizations<
  TData = Awaited<ReturnType<typeof getMeOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeOrganizations>>, TError, TData>>;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMeOrganizationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Accepts a pending invitation to join an organization. The invitation must be in 'Invited' state and not expired.
 * @summary Accept organization invitation
 */
export const postMeOrganizationsInvitationsAccept = (
  orgId: string,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<void>(
    { url: `/v1/me/organizations/${orgId}/invitations:accept`, method: 'POST', signal },
    options
  );
};

export const getPostMeOrganizationsInvitationsAcceptMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMeOrganizationsInvitationsAccept>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMeOrganizationsInvitationsAccept>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ['postMeOrganizationsInvitationsAccept'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMeOrganizationsInvitationsAccept>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return postMeOrganizationsInvitationsAccept(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMeOrganizationsInvitationsAcceptMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMeOrganizationsInvitationsAccept>>
>;

export type PostMeOrganizationsInvitationsAcceptMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Accept organization invitation
 */
export const usePostMeOrganizationsInvitationsAccept = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMeOrganizationsInvitationsAccept>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMeOrganizationsInvitationsAccept>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationOptions = getPostMeOrganizationsInvitationsAcceptMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Declines a pending invitation to join an organization. The invitation must be in 'Invited' state.
 * @summary Decline organization invitation
 */
export const postMeOrganizationsInvitationsDecline = (
  orgId: string,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<void>(
    { url: `/v1/me/organizations/${orgId}/invitations:decline`, method: 'POST', signal },
    options
  );
};

export const getPostMeOrganizationsInvitationsDeclineMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMeOrganizationsInvitationsDecline>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMeOrganizationsInvitationsDecline>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ['postMeOrganizationsInvitationsDecline'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMeOrganizationsInvitationsDecline>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return postMeOrganizationsInvitationsDecline(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMeOrganizationsInvitationsDeclineMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMeOrganizationsInvitationsDecline>>
>;

export type PostMeOrganizationsInvitationsDeclineMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Decline organization invitation
 */
export const usePostMeOrganizationsInvitationsDecline = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMeOrganizationsInvitationsDecline>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMeOrganizationsInvitationsDecline>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationOptions = getPostMeOrganizationsInvitationsDeclineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Records the user's acceptance of an agreement (Privacy Policy or Terms of Use). The version must be the currently active version.
 * @summary Accept agreement
 */
export const postMeAgreementsAccept = (
  acceptAgreementRequest: AcceptAgreementRequest,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<void>(
    {
      url: `/v1/me/agreements/accept`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: acceptAgreementRequest,
      signal,
    },
    options
  );
};

export const getPostMeAgreementsAcceptMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMeAgreementsAccept>>,
    TError,
    { data: AcceptAgreementRequest },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMeAgreementsAccept>>,
  TError,
  { data: AcceptAgreementRequest },
  TContext
> => {
  const mutationKey = ['postMeAgreementsAccept'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMeAgreementsAccept>>,
    { data: AcceptAgreementRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postMeAgreementsAccept(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMeAgreementsAcceptMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMeAgreementsAccept>>
>;
export type PostMeAgreementsAcceptMutationBody = AcceptAgreementRequest;
export type PostMeAgreementsAcceptMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Accept agreement
 */
export const usePostMeAgreementsAccept = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMeAgreementsAccept>>,
      TError,
      { data: AcceptAgreementRequest },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMeAgreementsAccept>>,
  TError,
  { data: AcceptAgreementRequest },
  TContext
> => {
  const mutationOptions = getPostMeAgreementsAcceptMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the notification settings for the currently authenticated user.
 * @summary Get notification settings
 */
export const getMeNotificationSettings = (
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<NotificationSettingsResponse>(
    { url: `/v1/me/notification-settings`, method: 'GET', signal },
    options
  );
};

export const getGetMeNotificationSettingsQueryKey = () => {
  return [`/v1/me/notification-settings`] as const;
};

export const getGetMeNotificationSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeNotificationSettings>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMeNotificationSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof instance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeNotificationSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeNotificationSettings>>> = ({
    signal,
  }) => getMeNotificationSettings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeNotificationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMeNotificationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeNotificationSettings>>
>;
export type GetMeNotificationSettingsQueryError = ErrorType<ProblemDetails>;

export function useGetMeNotificationSettings<
  TData = Awaited<ReturnType<typeof getMeNotificationSettings>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeNotificationSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeNotificationSettings>>,
          TError,
          Awaited<ReturnType<typeof getMeNotificationSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeNotificationSettings<
  TData = Awaited<ReturnType<typeof getMeNotificationSettings>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeNotificationSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeNotificationSettings>>,
          TError,
          Awaited<ReturnType<typeof getMeNotificationSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeNotificationSettings<
  TData = Awaited<ReturnType<typeof getMeNotificationSettings>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeNotificationSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get notification settings
 */

export function useGetMeNotificationSettings<
  TData = Awaited<ReturnType<typeof getMeNotificationSettings>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeNotificationSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMeNotificationSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates the notification settings for the currently authenticated user. Uses upsert behavior - only updates settings specified in the request.
 * @summary Update notification settings
 */
export const putMeNotificationSettings = (
  updateNotificationSettingsRequest: UpdateNotificationSettingsRequest,
  options?: SecondParameter<typeof instance>
) => {
  return instance<void>(
    {
      url: `/v1/me/notification-settings`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateNotificationSettingsRequest,
    },
    options
  );
};

export const getPutMeNotificationSettingsMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMeNotificationSettings>>,
    TError,
    { data: UpdateNotificationSettingsRequest },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMeNotificationSettings>>,
  TError,
  { data: UpdateNotificationSettingsRequest },
  TContext
> => {
  const mutationKey = ['putMeNotificationSettings'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMeNotificationSettings>>,
    { data: UpdateNotificationSettingsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return putMeNotificationSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMeNotificationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMeNotificationSettings>>
>;
export type PutMeNotificationSettingsMutationBody = UpdateNotificationSettingsRequest;
export type PutMeNotificationSettingsMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update notification settings
 */
export const usePutMeNotificationSettings = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMeNotificationSettings>>,
      TError,
      { data: UpdateNotificationSettingsRequest },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMeNotificationSettings>>,
  TError,
  { data: UpdateNotificationSettingsRequest },
  TContext
> => {
  const mutationOptions = getPutMeNotificationSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
